/* PAN HOMZ v5 — actual right/left variant + correct chaise preview.
   Real direction-specific photos take precedence; for a shared photo only,
   use a horizontal preview mirror based on the tagged source orientation. */
(() => {
  'use strict';
  const RIGHT = new Set(['يمين', 'right']);
  const LEFT = new Set(['شمال', 'يسار', 'left']);
  const normalize = (value) => String(value || '').trim().toLowerCase();

  function readSelection(info) {
    const picker = info.querySelector('variant-selects');
    if (!picker) return null;
    try {
      const variants = JSON.parse(picker.querySelector('[data-pan-variant-map]')?.textContent || '[]');
      const names = Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown'));
      const index = names.findIndex((field) => field.classList.contains('product-form__input--pan-direction'));
      if (index < 0) return null;
      const dirControls = Array.from(names[index].querySelectorAll('input[type="radio"]'));
      const dirValues = dirControls.map((x) => normalize(x.value));
      if (!(dirValues.some((x) => LEFT.has(x)) && dirValues.some((x) => RIGHT.has(x)))) return null;
      const values = names.map((field) => {
        const select = field.querySelector('select');
        return select ? select.value : field.querySelector('input[type="radio"]:checked')?.value;
      });
      if (values.some((x) => x == null)) return null;
      const selected = variants.find((v) => v.options?.length === values.length &&
        v.options.every((value, i) => value === values[i]));
      if (!selected) return null;
      const opposite = variants.find((v) => String(v.id) !== String(selected.id) &&
        v.options?.[index] !== selected.options[index] &&
        v.options?.every((value, i) => i === index || value === selected.options[i]));
      const current = normalize(values[index]);
      const selectedLeft = LEFT.has(current);
      const selectedRight = RIGHT.has(current);
      if (!(selectedLeft || selectedRight)) return null;
      const selectedMedia = selected.featured_media?.id || selected.featured_image?.id;
      const oppositeMedia = opposite?.featured_media?.id || opposite?.featured_image?.id;
      const shared = Boolean(selectedMedia && oppositeMedia && String(selectedMedia) === String(oppositeMedia));
      const originalLeft = info.dataset.chaiseOriginalDirection === 'left';
      return { shared, mirror: shared && selectedLeft !== originalLeft, selectedLeft };
    } catch (e) {
      console.warn('PAN HOMZ: cannot resolve selected chaise direction', e);
      return null;
    }
  }

  function apply(info) {
    if (!info) return;
    const selection = readSelection(info);
    info.classList.toggle('pan-homz-chaise-mirrored', Boolean(selection?.mirror));
    info.classList.toggle('pan-homz-chaise-preview', Boolean(selection?.mirror));
    info.classList.remove('pan-shared-direction-media');
    const modal = document.getElementById(`ProductModal-${info.dataset.section || info.dataset.originalSection}`);
    modal?.classList.toggle('pan-homz-chaise-mirrored', Boolean(selection?.mirror));
  }
  function applyAll() {
    document.querySelectorAll('product-info').forEach(apply);
  }
  document.addEventListener('change', (event) => {
    const info = event.target.closest?.('product-info');
    if (!info) return;
    apply(info);  // immediate response on the click
    requestAnimationFrame(() => apply(info));
  });
  document.addEventListener('product-info:loaded', (event) => apply(event.target));
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(applyAll));
  }
  // Product-info AJAX replaces the variant selector DOM without changing
  // the product-info element. Recheck after the partial HTML update.
  const scheduleApply = (event) => {
    if (event?.target?.closest?.('product-info')) {
      requestAnimationFrame(() => apply(event.target.closest('product-info')));
    }
  };
  document.addEventListener('input', scheduleApply);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }
})();
